import React from 'react'
import { FormattedMessage } from 'react-intl'

export default function Translator(id, defaultMsg) {
    return (
        <FormattedMessage id={id} defaultMessage={defaultMsg} />
    )
}
